<template>
  <div>
    <div id="app" :style="{'background-color': material.backgroundColor}">
      <div v-if="$route.name !== 'rule'" class="bg-img" :style="{'background-image': 'url('+material.indexHeadImage+')', 'background-size': '100% auto'}">
        <div class="rule" @click="toRule">
          <!-- 规则 -->
          <img src="https://static.didapinche.com/pics/g/04tx1mlnsvrule.png" alt="" class="rule-img">
        </div>
      </div>
      <home v-if="Object.keys(predictData).length > 0" />
    </div>
    <loading v-if="isloading" />
  </div>
</template>
<script>
import { predictCoupons, helpGuest } from '@/api'
import home from './views/Home/index.vue'
import loading from './views/loading/loading.vue'
import { BsGetCid, BsShare, BsGetEnv, BsGetXcx, BsUtil } from 'dida-web-common'
export default {
  components: {
    home,
    loading
  },
  data: () => {
    return {
      errorMessage: '',
      material: {
        backgroundColor: '#FFFAEB',
        indexHeadImage: 'https://static.didapinche.com/pics/g/4a2usnepnqhheadnew.png'
      }, // 素材
      predictData: {},
      isloading: true
    }
  },
  async created() {
    await this.initPredictCoupon()
  },
  mounted() {
    this.setCurrentEnv()
  },
  beforeDestroy() {
    if (BsGetEnv.inWechat) {
      window.removeEventListener('popstate', this.goBack, false)
    }
  },
  methods: {
      /*
    * 静默登录会导致返回多一层, 此处解决返回问题
    */
    resetGoBack() {
      // 安卓微信H5需要交互才出发popstate
      // 以下类似于触发解决
      try {
        window.tbs_bridge.nativeExec('network', 'type', 0, null)
      } catch (e) {
        console.log(e)
      }
      pushHistory()
      window.addEventListener('popstate', this.goBack, false)
      function pushHistory() {
        var state = {
          title: 'title',
          url: '#'
        }
        window.history.pushState(state, 'title', '#')
      }
    },
    /*
    * 配合上面从写返回
    */
    goBack() {
      const code = BsUtil.queryString('code')
      if (code) {
        // console.log(2222222)
        try {
           window.WeixinJSBridge.call('closeWindow') // 微信，只是微信就用这个API。
        } catch (error) {
          console.log(error)
        }
      } else {
        // window.history.go(-(window.history.length - 1))
      }
    },
    async closeLoading(flag) {
      const code = BsUtil.queryString('code')
      const xcx = await BsGetXcx()
      const { cid } = await BsGetCid()
      if (!code || (code && cid) || flag || (code && !(!xcx.isWx && BsGetEnv.inWechat))) {
        this.isloading = false
      }
    },
    async setCurrentEnv() {
      const xcx = await BsGetXcx()
      const code = BsUtil.queryString('code')
      if (xcx.isWx) {
          this.$root.client = 'minipg_carpool_wx'
      } else if (xcx.isAli) {
          this.$root.client = 'xuminipg_carpool_ali'
      } else if (BsGetEnv.inApplication) {
          this.$root.client = 'app'
      } else if (BsGetEnv.inWechat) {
          this.$root.client = 'carpool_wx'
          code && this.resetGoBack()
      } else if (BsGetEnv.isAlipay) {
          this.$root.client = 'carpool_ali'
      } else {
        this.$root.client = 'h5'
      }
    },

    // 获取小程序分享路径
    sharePath(url) {
      return 'pages/index?type=share&sharepath=' + encodeURIComponent('/pages/webviewact?url=' + encodeURIComponent(url))
    },
    // app右下角分享
    initShare() {
      const objShare = {
        data: {
          title: '你的好友送你出行补贴',
          desc: '领券出行更优惠',
          link: `${window.location.origin}/web-new-coupon/?activityCode=${this.$root.activityCode}${this.$root.channelType ? '&channelType=' + this.$root.channelType : ''}${this.$root.terminalType ? '&terminalType=' + this.$root.terminalType : ''}`,
          imgUrl: 'https://static.didapinche.com/pics/g/odjcto352zishare.png'
        },
        shareByApp: {
          enable: true
        },
        shareByWx: {
          enable: true
        },
        shareByMinipg: {
          enable: true,
          link: this.sharePath(window.location.origin + '/web-new-coupon/' + '?activityCode=' + this.$root.activityCode + '&channelType' + this.$root.channelType + '&terminalType' + this.$root.terminalType)
          // imgUrl: this.defaultData.miniImage
        }
      }
      new BsShare(objShare)
    },
    toRule() {
      this.$router.push({ path: `/rule${window.location.search}` })
    },
    async initPredictCoupon(helpRequested = false) {
      // this.isloading = true
      // this.predictData = {}

      const { cid } = await BsGetCid()
      const obj = {
        userCid: cid,
        activityCode: this.$root.activityCode,
        channelType: this.$root.channelType, // 渠道类型
        terminalType: this.$root.client	// 终端类型
      }
      predictCoupons(obj).then(async res => {
        const shareCode = BsUtil.queryString('shareCode')
        // const isUnclaimed = res?.data?.code === 0 && res.data?.data?.isAward === false
        if (cid && res.data.code === 0 && res.data?.data?.isAward && shareCode && !helpRequested) {
          try {
            const helpData = { shareCode, resultType: 0, terminalType: 3, userCid: cid }
            const entry = BsUtil.queryString('entry')
            if (entry) helpData.entry = entry
            await helpGuest(helpData)
          } catch (e) {
            console.error(e)
          }
        }
        this.predictData = res.data
        this.material.backgroundColor = res.data.data.activityInfo.material.backgroundColor
          ? res.data.data.activityInfo.material.backgroundColor : '#FFFAEB'
        this.material.indexHeadImage = res.data.data.activityInfo.material.indexHeadImage
          ? res.data.data.activityInfo.material.indexHeadImage : 'https://static.didapinche.com/pics/g/4a2usnepnqhheadnew.png'
        if (res.data.code === 0) {
          this.initShare()
        } else {
          this.errorMessage = res.data.data.errorMsg ? res.data.data.errorMsg : res.data.message
          this.$didafe.toast(this.errorMessage, { duration: 2000 })
        }
      }).catch(e => {
        console.error(e)
        this.closeLoading(true)
      })
    }
  },
  provide() {
    return {
      predictData: () => this.predictData,
      initPredictCoupon: this.initPredictCoupon,
      closeLoading: this.closeLoading
    }
  }
}
</script>
<style lang="scss" scoped>
  #app {
    width: 100vw;
    min-height: 100vh;
    overflow-x: hidden;
    // padding-top: 4.23rem;
    .bg-img {
      width: 7.5rem;
      height: 4.23rem;
      background-repeat: no-repeat;
      background-size: 100% auto;
      position: relative;
       .rule {
         .rule-img {
            position: absolute;
            right: 0;
            top: 1.4rem;
            width: 1.08rem;
            height: 0.71rem;
         }
      }
    }
  }
  .loading {
    width: 100vw;
    height: 100vh;
  }
</style>
